export class ThirdTab {
  userId: string;
  iban: string;
  orderNumber: string;
  address: string;
  city: string;
  district: string;
  town: string;
  email: string;
  identityNumber: string;
  name: string;
  phoneNumber: number;
  surname: string;
  isCashback: boolean;
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/shared/classes/third-tab.model.ts